import App from './App.vue'
import Error from './Error.vue'
import router from './router'
import store from './store'

import AdalAuthentication from '@/adal-auth'
import { GET_CURRENT_USER, FETCH_APPSETTINGS } from '@/store/action-type'

import { createApp, reactive } from 'vue';
import Emitter from 'tiny-emitter';

//Vue.config.productionTip = false

const showApp = () => {
  const app = createApp(App);
  app.use(store);
  app.use(router);
  const eventBus = new Emitter();
  app.provide('eventBus', eventBus);

  app.mount('#app');
}

const showError = (error) => {
  const app = createApp(Error);
  const eventBus = new Emitter();
  app.provide('eventBus', eventBus);

  app.mount('#app');
}

AdalAuthentication.initialize()
  .then((result) => {
    const tasks = []
    tasks.push(store.dispatch(GET_CURRENT_USER))
    tasks.push(store.dispatch(FETCH_APPSETTINGS))
    return Promise.all(tasks)
  })
  .then(showApp)
  .catch((error) => {
    console.log(error)
    showError(error)
  })
